'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var List = require('./list')
//var EditNew = require('./edit_new')

var ClientsGroupsModule = function () {

  //
  var API = {
    list: function (options) {
      var list = new List(options)
    }
    // editNew: function (options) {
    //   new EditNew(options)
    // }
  }

  // App.listenTo(ContactManager, 'contact:show', function (id) {
  //   console.log('oh yeah, thats deep')
  // })
  App.globalChannel.on('client-groups:list', function (options) {
    API.list(options)
  })

  // App.globalChannel.on('client-groups:new', function (options) {
  //   API.editNew(options)
  // })

  // App.globalChannel.on('client-groups:edit', function (options) {
  //   API.editNew(options)
  // })

  // App.globalChannel.on('client:show', function (options) {
  //   App.globalChannel.trigger('app:navigate', 'test/' + options.model.id)
  //   API.showClient(options.model.id, options.model)
  // // console.log(client)
  // })
  // App.vent.on "crew:member:clicked crew:created", (member) ->
  //   App.navigate Routes.edit_crew_path(member.id)
  //   API.edit member.id, member

// fire this up on an global app event
// new Router({ controller: API })
}

module.exports = ClientsGroupsModule



// WEBPACK FOOTER //
// ./js/modules/client-groups/index.js